const ROOT = "divider";
export {
  ROOT
};
//# sourceMappingURL=dataHooks.js.map
